import styled from 'styled-components';
import Icon from 'components/global/Icon/Primary';
import type { Product } from 'entities/product';
import type { BundleInfoModule } from 'lib/pdp-modules/types';

const BundleInfoWrapper = styled.div`
  border-top: 1px solid #d2d8d0;
  padding: 1rem 0;
`;

const ULList = styled.ul`
  padding-left: 1rem;
  list-style-type: disc;
  list-style-position: outside;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
  font-weight: 350;
  line-height: 140%;
  letter-spacing: -0.16px;
`;

const ClinicalLink = styled.a`
  margin-left: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  text-underline-offset: 0.5rem;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.04px;
`;

type ProductBundleInfoProps = {
  selectedProduct: Pick<Product, 'name'>;
  bundleProduct: Pick<Product, 'name'>;
  bundleProducts?: BundleInfoModule;
};

const ProductBundleInfo = ({
  selectedProduct,
  bundleProduct,
  bundleProducts,
}: ProductBundleInfoProps) => {
  if (!bundleProducts) {
    return null;
  }

  return (
    <BundleInfoWrapper>
      <ULList>
        <ListItem>
          <b>{selectedProduct.name}:</b>&nbsp;
          {bundleProducts.products[0]?.description}
        </ListItem>
        <ListItem>
          <b>{bundleProduct.name}:</b>&nbsp;
          {bundleProducts.products[1]?.description}
        </ListItem>
        {bundleProducts.extraBulletPoint && (
          <ListItem>{bundleProducts.extraBulletPoint}</ListItem>
        )}
      </ULList>
      {!!bundleProducts.clinicalTrialsLink && (
        <ClinicalLink href={bundleProducts.clinicalTrialsLink}>
          See Clinical Evidence
          <Icon name='arrow-right' size='md' />
        </ClinicalLink>
      )}
    </BundleInfoWrapper>
  );
};

export default ProductBundleInfo;
